var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51855 1.62256C9.86746 1.43089 10.3055 1.46278 10.625 1.71826L16.875 6.71826C17.1121 6.90794 17.2499 7.1959 17.25 7.49951V17.4995C17.25 18.0518 16.8023 18.4995 16.25 18.4995H3.75C3.19772 18.4995 2.75 18.0518 2.75 17.4995V7.49951C2.75014 7.1959 2.88791 6.90794 3.125 6.71826L9.375 1.71826L9.51855 1.62256ZM7.91699 11.2495C7.45701 11.2495 7.08342 11.6226 7.08301 12.0825V16.6665H12.917V12.0825C12.9166 11.6226 12.543 11.2495 12.083 11.2495H7.91699Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFill);
export default __webpack_public_path__ + "static/media/home-fill.0e127c361358902b38db0d1926a157bd.svg";
export { ForwardRef as ReactComponent };